export const tissueLabels = {
  adiposeSubcutaneous: 'Adipose - Subcutaneous',
  adiposeVisceralOmentum: 'Adipose - Visceral (Omentum)',
  adrenalGland: 'Adrenal Gland',
  arteryAorta: 'Artery - Aorta',
  arteryCoronary: 'Artery - Coronary',
  arteryTibial: 'Artery - Tibial',
  bladder: 'Bladder',
  brainAmygdala: 'Brain - Amygdala',
  brainAnteriorcingulatecortexBa24: 'Brain - Anterior cingulate cortex (BA24)',
  brainCaudateBasalganglia: 'Brain - Caudate (basal ganglia)',
  brainCerebellarhemisphere: 'Brain - Cerebellar Hemisphere',
  brainCerebellum: 'Brain - Cerebellum',
  brainCortex: 'Brain - Cortex',
  brainFrontalcortexBa9: 'Brain - Frontal Cortex (BA9)',
  brainHippocampus: 'Brain - Hippocampus',
  brainHypothalamus: 'Brain - Hypothalamus',
  brainNucleusaccumbensBasalganglia: 'Brain - Nucleus accumbens (basal ganglia)',
  brainPutamenBasalganglia: 'Brain - Putamen (basal ganglia)',
  brainSpinalcordCervicalc1: 'Brain - Spinal cord (cervical c-1)',
  brainSubstantianigra: 'Brain - Substantia nigra',
  breastMammarytissue: 'Breast - Mammary Tissue',
  cellsEbvTransformedlymphocytes: 'Cells - EBV-transformed lymphocytes',
  cellsTransformedfibroblasts: 'Cells - Transformed fibroblasts',
  cervixEctocervix: 'Cervix - Ectocervix',
  cervixEndocervix: 'Cervix - Endocervix',
  colonSigmoid: 'Colon - Sigmoid',
  colonTransverse: 'Colon - Transverse',
  esophagusGastroesophagealjunction: 'Esophagus - Gastroesophageal Junction',
  esophagusMucosa: 'Esophagus - Mucosa',
  esophagusMuscularis: 'Esophagus - Muscularis',
  fallopianTube: 'Fallopian Tube',
  heartAtrialappendage: 'Heart - Atrial Appendage',
  heartLeftventricle: 'Heart - Left Ventricle',
  kidneyCortex: 'Kidney - Cortex',
  liver: 'Liver',
  lung: 'Lung',
  minorSalivaryGland: 'Minor Salivary Gland',
  muscleSkeletal: 'Muscle - Skeletal',
  nerveTibial: 'Nerve - Tibial',
  ovary: 'Ovary',
  pancreas: 'Pancreas',
  pituitary: 'Pituitary',
  prostate: 'Prostate',
  skinNotsunexposedSuprapubic: 'Skin - Not Sun Exposed (Suprapubic)',
  skinSunexposedLowerleg: 'Skin - Sun Exposed (Lower leg)',
  smallIntestineTerminalileum: 'Small Intestine - Terminal Ileum',
  spleen: 'Spleen',
  stomach: 'Stomach',
  testis: 'Testis',
  thyroid: 'Thyroid',
  uterus: 'Uterus',
  vagina: 'Vagina',
  wholeBlood: 'Whole Blood',
}
